// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__QFq6A","signatureBlock":"Footer_signatureBlock__3ot-F","signature":"Footer_signature__1TqKw"};